
import ReactGA from 'react-ga'
import {
    useNavigate
} from "react-router";


export const useNavigator = () => {

    let loggedUser = JSON.parse(localStorage.getItem("exsportLogin"))
    let Search = localStorage.getItem("search")
    const naviagte = useNavigate()
    console.log(Search)


    const navigator = (path = '/', data = null) => {
        console.log(path)
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYST}`)
        console.log(window?.location?.origin)
        ReactGA.pageview(window?.location?.origin + path)
        if (Search != null && Search != undefined) {
            console.log(document.getElementById("searchnft"))
            document.getElementById("searchnft")?.click()
            naviagte(path)
        }
        if (data != null) {
            naviagte(path)
        }
        else {
            if (path == '/') {
                naviagte('/')
            }
            else {
                if (loggedUser != null) {
                    naviagte('/login')
                }
                else {
                    naviagte(path)

                }
            }
        }
    }

    return [navigator]

}
